// getAuth() pega a instância do app já inicializado em services/firebase.ts,
// sem importar aquele arquivo (que importa este, via pushApi).
import { getAuth } from 'firebase/auth';

// Configuração da API - detecta automaticamente localhost ou produção
const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

export const API_BASE_URL = isDevelopment
  ? 'http://localhost:5001'
  : window.location.origin;

// A mesma função serverless atende produção (Vercel) e desenvolvimento
// (server/start-server.js monta o mesmo handler), sempre com ?action=
const notificationsUrl = (action: string) => `${API_BASE_URL}/api/notifications?action=${action}`;

export const API_ENDPOINTS = {
  notifications: {
    audience: notificationsUrl('audience'),
    stats: notificationsUrl('stats'),
    createCampaign: notificationsUrl('create-campaign'),
    cancelCampaign: notificationsUrl('cancel-campaign'),
    notifyUser: notificationsUrl('notify-user'),
    uploadImage: notificationsUrl('upload-image'),
    defaultLogo: notificationsUrl('default-logo'),
  }
};

/** fetch com o ID token do admin logado — a API recusa chamadas sem ele. */
export const authFetch = async (url: string, init: RequestInit = {}): Promise<Response> => {
  const user = getAuth().currentUser;
  if (!user) {
    throw new Error('Sessão expirada. Faça login novamente');
  }

  const headers = new Headers(init.headers);
  headers.set('Authorization', `Bearer ${await user.getIdToken()}`);
  if (init.body && !headers.has('Content-Type')) {
    headers.set('Content-Type', 'application/json');
  }
  return fetch(url, { ...init, headers });
};
